<template>
    <div>
        <div v-if="busy" class="PageLoader__spinner">
            <i class="fa fa-circle-o-notch fa-spin" :class="{ visible: isSlow }"></i>
        </div>
        <div ref="page-content" class="PageLoader__content" :class="{ visible: ready }">
            <slot v-if="!busy"></slot>
        </div>
    </div>
</template>

<style>
.PageLoader__spinner {
    padding-top: 20%;
    padding-bottom: 20%;
    text-align: center;
}
.PageLoader__spinner .fa {
    font-size: 30px;
}
.PageLoader__spinner .fa,
.PageLoader__content {
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
}
.PageLoader__spinner .fa.visible,
.PageLoader__content.visible {
    opacity: 1;
}
</style>

<script type="text/babel">
export default {
    props: {
        loading: {
            default: true,
        },
    },

    data() {
        return {
            ready: false,
            redirecting: false,
            isSlow: false,
        }
    },

    computed: {
        busy() {
            return this.loading || this.redirecting
        },
    },

    watch: {
        loading: function(loading) {
            if (loading) {
                this.startSlowTimer()
            }
            this.ready = !loading
        },
    },

    created() {
        this.ready = !this.loading

        Bus.$on('page.redirect', params => {
            this.$get(params, 'options.back', false) ? this.animateBack() : this.animateForward()
        })

        this.startSlowTimer()
    },

    mounted() {
        //             $(this.$el).on('click', 'a.btn-animate', () => {
        // //                this.animateForward();
        //             })
    },

    methods: {
        animate(animateClass) {
            this.$refs['page-content'].classList.add('animated')
            this.$refs['page-content'].classList.add(animateClass)

            setTimeout(() => (this.redirecting = true), 200)
        },

        animateBack() {
            this.animate('fadeOutRightBig')
        },

        animateForward() {
            this.animate('fadeOutLeftBig')
        },

        startSlowTimer() {
            this.isSlow = false

            setTimeout(() => (this.isSlow = true), 300)
        },
    },
}
</script>
